module.exports = __webpack_public_path__ + "img/datakitchen__logo.a65c0f07.png";